<template>
  <div class="cartcontrol">
		<transition name="move"> 
    <div class="cart-decrease icon-remove_circle_outline" v-show="food.count"	@click.stop="decreaseCart"></div>
		</transition>
    <div class="cart-count"  v-show="food.count">{{food.count}}</div>
      <div 
        class="cart-add icon-add_circle"	@click.stop.prevent="increaseCart">
        <i class="bg"></i>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default { 
  name: 'HelloWorld',
  data () {
	    return {
	      postInfo: {},
	    }
	},
	methods: {
		decreaseCart(){
			//开启锁定库存
			if(this.lock == '1'){
				this.$emit("dec_times")
				console.log(this.c_num)
				this.postInfo= { "imei":this.imei, "No":this.food.No, "c_num":this.c_num }
				console.log(this.postInfo)
				const url = "https://home.hrcc7.com/server/c/dec_goods"
				this.axios.post(   //请求方式
				url,  //减少商品接口地址
				this.postInfo  //传递参数 
				)    
				.then(response =>{
					if(response.data.code == 2000){
						this.food.stock = response.data.data.stock
						if(this.food.count > 0){
							console.log(this.food.count)
							this.food.count--
						}
					}else{
						//提示异常
						var info = response.data.msg
						this.$emit("showTips",info)
					}
				})
			}
			//未开启锁定库存
			if(this.lock == '0'){
				if(this.food.count > 0){
					console.log(this.food.count)
					this.food.count--
				}
	}
			
		},
		increaseCart(){
			console.log(this.lock)
			if(this.selectCount > this.cartNum){
				var info = "购物车商品数量已经达到"+ this.cartNum +"个"
				this.$emit("showTips",info)
				return
			}
			if(this.food.stock <= 0){
				var info = "已达到该货道可出货商品的最大数量"
				this.$emit("showTips",info)
				return
			}
			if(this.lock == '1'){
				this.$emit("dec_times")
				console.log(this.c_num)
				console.log(this.food)
				this.postInfo= { "imei":this.imei, "No":this.food.No, "c_num":this.c_num }
				console.log(this.postInfo)
				const url = "https://home.hrcc7.com/server/c/add_goods"
				this.axios.post(   //请求方式
				url,  //添加商品接口地址
				this.postInfo  //传递参数 
				)    
				.then(response =>{
					if(response.data.code == 2000){
							if(!this.food.count){
								if(this.selectCount <= this.cartNum){
									console.log('*')
									this.food.stock = response.data.data.stock
									if(response.data.data.before_stock > 0){ //库存大于0才能加入购物车
										Vue.set(this.food,'count',1)
									}
								}else{
									var info = "购物车商品数量已经达到"+this.cartNum+"个"
									this.$emit("showTips",info)
								}
							}else{
								console.log(this.food.count)
								if(this.food.count > 0 && this.selectCount <= this.cartNum && this.food.stock > 0){
									console.log("**")
									console.log(this.selectCount)
									this.food.stock = response.data.data.stock
									if(response.data.data.before_stock > 0){
										this.food.count++
									}
								}else{
									if(this.food.stock <= 0){
										var info = "已达到该货道可出货商品的最大数量"
										this.$emit("showTips",info)
									}else if(this.selectCount > this.cartNum){
										var info = "购物车商品数量已经达到"+this.cartNum+"个"
										this.$emit("showTips",info)
									}
								}
							}
					}else{
						//提示异常
						var info = response.data.msg
						this.$emit("showTips",info)
					}
				})
			}
			if(this.lock == '0'){
				if(!this.food.count){
       				if(this.selectCount <= this.cartNum){
						console.log('*')
						Vue.set(this.food,'count',1)
					}else{
						var info = "购物车商品数量已经达到"+this.cartNum+"个"
						this.$emit("showTips",info)
					}
				}else{
					if(this.food.count < this.food.stock && this.selectCount <= this.cartNum){
						console.log("**")
						console.log(this.selectCount)
						this.food.count++
					}else{
						if(this.food.count >= this.food.stock){
							var info = "已达到该货道可出货商品的最大数量"
							this.$emit("showTips",info)
						}else if(this.selectCount > this.cartNum){
							var info = "购物车商品数量已经达到"+this.cartNum+"个"
							this.$emit("showTips",info)
						}
					}
				}
			}
		}
	},
	props:{
		food:{
			type:Object
		},
		selectCount:{
			type:Number
		},
		c_num:{
			type:String
		},
		imei:{
			type:String
		},
		lock:{
			type:String
		},
		lock_times:{
			type:Number
		},
		cartNum:{
			type:Number
		}
	}
}
</script>


<style scoped>
@import url('../../common/css/style.css');
.cartcontrol{
	font-size: 0;
}

.cartcontrol .cart-decrease{
	display: inline-block;
	width: 26px;
	height: 26px;
	font-size: 26px;
	color: #b4b4b4;
}

.cartcontrol .cart-add .bg{
	width: 20px;
	height: 20px;
	border-radius: 50%;
	background: black;
	position: absolute;
	left: 3px;
	top: 3px;
	z-index: -1;
}


.cartcontrol .cart-count{
	display: inline-block;
	width: 25px;
	text-align: center;
	font-size: 12px;
	line-height: 26px;
	vertical-align: top;
}

.cartcontrol .cart-add{
	display: inline-block;
	width: 26px;
	height: 26px;
	font-size: 26px;
	color: #ffd161;
	position: relative;
}
.move-enter-active,.move-leave-active{
	transition: all 0.3s linear;
}
.move-enter,.move-leave-to{
	transform: translateX(20px) rotate(180deg);
}
</style>


// WEBPACK FOOTER //
// src/components/cartcontrol/Cartcontrol.vue